import {FC, useEffect} from 'react';
import {useParams, useSearchParams} from 'react-router-dom';
import {useNavigate} from 'react-router';
import {api, EOAuthType} from '@kcast-fe/core';
import {ROUTES} from 'core';

const OAuthCallbackSceneFC: FC = () => {
  const [searchParams] = useSearchParams();
  const {type} = useParams();

  const {mutateAsync} = api.oauth.useAuthCallbackMutation();

  const navigate = useNavigate();

  useEffect(() => {
    mutateAsync({oauthType: type as EOAuthType, params: searchParams.toString()}).then(() =>
      navigate(ROUTES.Chat.Root, {replace: true})
    );
  }, [mutateAsync, navigate, searchParams, type]);

  return <></>;
};

export const OAuthCallbackScene = OAuthCallbackSceneFC;
